export default __webpack_public_path__ + "static/media/latest-news-img20.46ab4b3d.jpg";